module.exports = __webpack_public_path__ + "img/excise.b1ab47f2.png";